import AOS from "aos";

AOS.init({
    once: false,
    duration: 1000,
});

document.querySelectorAll("img").forEach((img) => img.addEventListener("load", () => AOS.refresh()));
